// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 53 ? "5e3fcbca" : chunkId) + "." + {"53":"eeede102ef1ba2d5","802":"7e649012ae4a3871"}[chunkId] + ".js";
};